import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class VisibilitatMapaService {

    static changeVisibilityMap(businessId, visibilitat){
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.changeVisibilityMapUrl, { uid: uid, businessId: businessId, visibilitat: visibilitat}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/visibilitat-modal/services/visibilitatMapaService.js